/**
 * Table headers for countries
 * @type {Array}
 */
export const HEADERS_COUNTRIES = [
    {
        key: "name",
        label: "Country",
        sortable: true,
        thStyle: { minWidth: "150px" },
        class: "text-left"
    },
    {
        key: "code",
        label: "Country Code",
        sortable: true,
        thStyle: { minWidth: "120px" },
        class: "alinmov6"
    },
    {
        key: "description",
        label: "Short Description",
        sortable: true,
        thStyle: { minWidth: "80px" },
        class: "text-left"
    },
    {
        key: "citiesCount",
        label: "Cities N° ",
        sortable: true,
        thStyle: { minWidth: "100px" },
        class: "alinmov6"
    },

    {
        key: "visibilityStatus",
        label: "Visibility",
        sortable: true,
        thStyle: { minWidth: "150px" },
        class: "alinmov6"
    },
    {
        key: "status",
        label: "Status",
        sortable: true,
        thStyle: { minWidth: "100px" },
        class: "alinmov6"
    },
    {
        key: "actions",
        label: "Actions",
        sortable: false,
        class: "alinmov6",
        thStyle: { minWidth: "100px" }
    }
];

/**
 * Table headers for cities
 * @type {Array}
 */
export const HEADERS_CITIES = [
    {
        key: "name",
        label: "City",
        sortable: true,
        thStyle: { minWidth: "150px" },
        class: "text-left"
    },
    {
        key: "code",
        label: "IATA Code",
        sortable: true,
        thStyle: { minWidth: "120px" },
        class: "alinmov6"
    },
    {
        key: "country",
        label: "Country",
        sortable: true,
        thStyle: { minWidth: "150px" },
        class: "alinmov6"
    },
    {
        key: "description",
        label: "Short Description",
        sortable: true,
        thStyle: { maxWidth: "100px" },
        class: "text-left"
    },
    {
        key: "visibilityStatus",
        label: "Visibility",
        sortable: true,
        thStyle: { minWidth: "150px" },
        class: "alinmov6"
    },
    {
        key: "status",
        label: "Status",
        sortable: true,
        thStyle: { minWidth: "100px" },
        class: "alinmov6"
    },
    {
        key: "actions",
        label: "Actions",
        sortable: false,
        class: "alinmov6",
        thStyle: { minWidth: "100px" }
    }
];